import {jwtServerInstance} from "../index";
import qs from	'qs'


export const queryShareCode = () =>{
    return jwtServerInstance.request({
        url:'/b2csharecode/querysharecode',
        method:'post'
    })
}

export const reflushShareCode = (salemanId) =>{
    return jwtServerInstance.request({
        url:'/b2csharecode/reflushsharecode',
        method:'post',
        data: qs.stringify({
            userId:salemanId
        })
    })
}
